// Every row begins with a snapshot of the caller's UserSettings (currency +
// tax regime), then expense-level fields — mirroring the columns
// `expenses_slice_by_range` returns, in the same order.
const userContext = {
  userCurrency: 'GEL',
  userTaxFee: '1',
  userTaxBase: 'turnover',
  userAccountingBasis: 'cash',
  userVatStatus: 'notRegistered',
  userVatBasis: 'invoice',
  userVatThreshold: '100000',
  userVatThresholdWindow: 'rolling12Months',
};

const expensesRows: ReadonlyArray<Record<string, string | null>> = [
  {
    ...userContext,
    expenseId: 'Qd8H2pV0kLmN3rStUvWx',
    expenseDate: '2022-01-15',
    expenseName: 'GCP services',
    expenseDescription: 'Monthly cloud hosting',
    expenseCurrency: 'USD',
    expenseSum: '100.00',
    expenseExchangeRate: '2.9700',
    expenseVat: '0.00',
    expenseReverseChargeVat: 'false',
    expenseAmountRaw: '100.00',
    expenseAmount: '100.00',
    expenseVatAmount: '0.00',
  },
  {
    ...userContext,
    expenseId: 'Rf9J3qW1lMnO4sTuVwXy',
    expenseDate: '2022-02-10',
    expenseName: 'Figma subscription',
    expenseDescription: '',
    expenseCurrency: 'USD',
    expenseSum: '45.00',
    expenseExchangeRate: '2.8500',
    expenseVat: '18.00',
    expenseReverseChargeVat: 'true',
    expenseAmountRaw: '45.00',
    expenseAmount: '53.10',
    expenseVatAmount: '8.10',
  },
  {
    ...userContext,
    expenseId: 'Sg0K4rX2mNoP5tUvWxYz',
    expenseDate: '2022-03-01',
    expenseName: 'Office rent',
    expenseDescription: 'March',
    expenseCurrency: 'GEL',
    expenseSum: '800.00',
    expenseExchangeRate: '1.0000',
    expenseVat: '0.00',
    expenseReverseChargeVat: 'false',
    expenseAmountRaw: '800.00',
    expenseAmount: '800.00',
    expenseVatAmount: '0.00',
  },
];

const expensesQuery = `
  SELECT
  * FROM
  \`invoicemaker-f5e1d.mini_accountant.expenses_slice_by_range\`(
    PARSE_TIMESTAMP("%Y%m%d",  "20220101", "Asia/Tbilisi"),
    PARSE_TIMESTAMP("%Y%m%d", "20231231", "Asia/Tbilisi"),
    "Asia/Tbilisi"
  );
  `;

export { expensesRows, expensesQuery };
